import {
  Button,
  type InfoDataGridData,
  InfoDataTable,
  ModalComponentWrapper,
} from '@/shared/components/index.ts';
import type { OperationModalProps } from '@/shared/types';
import { cn } from '@/shared/utils';

interface ConfirmationModalProps extends OperationModalProps {
  onBack: () => void;
  onConfirmed: () => void;
  infoData: InfoDataGridData[];
  isLoading: boolean;
  footerWarning?: string;
  buttonText: string;
}

export const WithdrawConfirmationModal = ({
  title,
  onBack,
  infoData,
  onConfirmed,
  isLoading,
  footerWarning,
  buttonText,
}: ConfirmationModalProps) => {
  return (
    <>
      <ModalComponentWrapper
        title={title}
        onBack={onBack}
        footer={
          <div className="flex flex-col gap-[1.6rem]">
            <Button
              type="submit"
              variant="default"
              size="lg"
              disabled={isLoading}
              loading={isLoading}
              onClick={onConfirmed}
              className={cn('w-full')}>
              {buttonText}
            </Button>
            {footerWarning && (
              <div className="text-center p4 text-muted-foreground">
                {footerWarning}
              </div>
            )}
          </div>
        }>
        <div className="flex flex-col gap-[1.6rem]">
          {infoData.map((data, index) => (
            <InfoDataTable data={data} key={index} />
          ))}
        </div>
      </ModalComponentWrapper>
    </>
  );
};
